// extracted by mini-css-extract-plugin
module.exports = {"rightContainer":"CareTeam_rightContainer___W99c","leftContainer":"CareTeam_leftContainer__TVm98"};